export default function trace(...rest) {
  if (process.env.NODE_ENV !== 'production' && process.env.TRACE_ENABLED) {
    console.log('Trace:', ...rest)
  }
}
